import React from 'react';
import { Icon } from "semantic-ui-react";

import './Footer.css';

const Footer = () => {
  return (
    <div id="footer">
      <div>© MRVince Ltd. 2018. </div>
      <div>Company No. 11337089.</div>
      <div>
        <a href="mailto:admin@mrv.ltd">
          <Icon size='small' name='mail' inverted></Icon>
          Admin enquiries
        </a>
      </div>
      <div>
        <a href="https://s3-eu-west-1.amazonaws.com/mrv.ltd-policies/privacy_policy_13_09_18.pdf">
          Privacy Policy
        </a>
      </div>
      <div><a href="https://joshvince.site">Website by Josh</a></div>
    </div>
  );
};

export default Footer;


// WEBPACK FOOTER //
// ./src/Footer/Footer.js